import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { getlanguagelist } from "../../helpers/changelanguage";


class StaticFooter extends Component {

   componentDidMount(){
    
    document.querySelector('body').classList.remove('login_page');
    document.body.style.backgroundImage = "url('')";
   }

    backButton() {
      window.history.back();
    }
    render() {
      let  languagelist = getlanguagelist();
      return (
       
           
           
      

        <footer className="text-center">
            <div className=" container">
               <p>{languagelist.Staticfooter2}</p>
                <ul>
                    <li><a href="/terms_n_condition">{languagelist.Staticfooter3}</a></li>
                    <li><a href="/privacy_policy">{languagelist.Staticfooter4}</a></li>
                    <li><a href="/payment_policy">{languagelist.Staticfooter5}</a></li>
                    <li><a href="/refund_policy">{languagelist.Staticfoote6}</a></li>
                    <li><a href="/subscription_cancellation_policy">{languagelist.Staticfooter7}</a></li>
                    <li><a href="/delivery_policy">{languagelist.Staticfooter8}</a></li>            
                   {/*  <li><a href="/contact_us">{languagelist.Staticfooter9}</a></li> */}
                </ul>
            </div>
        </footer>
       
       
      
      );
    }
  }
export default StaticFooter;